import ContactSection from "./components/ContactSection";
import FAQSection from "./components/FAQSection";
import HeroSection from "./components/HeroSection";

const Index = () => {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <FAQSection />
      <ContactSection />
    </div>
  );
};

export default Index;
